var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0034 10C16.0034 7.25 13.0679 5 9.50783 5C5.91652 5 3.01225 7.25 3.01225 10C3.01225 11.0938 3.44945 12.0625 4.19894 12.875C3.76174 13.8438 3.07471 14.5938 3.07471 14.5938C3.01225 14.6562 2.98102 14.7812 3.01225 14.875C3.07471 14.9688 3.13717 15 3.26208 15C4.38632 15 5.32318 14.625 6.01021 14.2188C7.00953 14.7188 8.22745 15 9.50783 15C13.0679 15 16.0034 12.7812 16.0034 10ZM19.8133 16.875C20.5316 16.0625 21 15.0938 21 14C21 11.9375 19.3136 10.125 16.9403 9.375C16.9715 9.59375 17.0027 9.8125 17.0027 10C17.0027 13.3125 13.63 16 9.50783 16C9.16431 16 8.8208 16 8.50851 15.9688C9.4766 17.75 11.7875 19 14.5044 19C15.7848 19 16.9715 18.7188 17.9708 18.2188C18.6578 18.625 19.5947 19 20.7502 19C20.8439 19 20.9375 18.9688 20.9688 18.875C21 18.7812 21 18.6562 20.9063 18.5938C20.9063 18.5938 20.2193 17.8438 19.8133 16.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ac9c246ec5410cc31d7d5d7f3963c33f.svg";
export { ForwardRef as ReactComponent };